export default __webpack_public_path__ + "b8a4caad5543b1ff6531099031e75063.svg";